import React from 'react'
import CategoryRelevancy from '../components/CategoryRelevancy'
import { CategoryRelevancyProvider } from '../contexts/CategoryRelevancyContext'

const CategoryRelevancyPage = () => {
    return (
        <CategoryRelevancyProvider>
            <CategoryRelevancy />
        </CategoryRelevancyProvider>
    )
}

export default CategoryRelevancyPage